const DESKTOP_QUERY = '(min-width: 900px)';
const root = document.documentElement;
const siteStatus = document.querySelector('[data-site-status]');

function syncTheme() {
  const dark = root.dataset.theme === 'dark' || (!root.dataset.theme && matchMedia('(prefers-color-scheme: dark)').matches);
  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    button.setAttribute('aria-label', dark ? button.dataset.lightLabel : button.dataset.darkLabel);
  });
}

document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const dark = root.dataset.theme === 'dark' || (!root.dataset.theme && matchMedia('(prefers-color-scheme: dark)').matches);
    root.dataset.theme = dark ? 'light' : 'dark';
    try { localStorage.setItem('primelayer-theme', root.dataset.theme); } catch {}
    syncTheme();
    if (siteStatus) siteStatus.textContent = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
  });
});
matchMedia('(prefers-color-scheme: dark)').addEventListener('change', syncTheme);
syncTheme();

document.querySelectorAll('[data-mobile-nav]').forEach((menu) => {
  const summary = menu.querySelector('summary');
  menu.addEventListener('click', (event) => { if (event.target.closest('a')) menu.open = false; });
  document.addEventListener('pointerdown', (event) => { if (!menu.contains(event.target)) menu.open = false; });
  document.addEventListener('focusin', (event) => { if (!menu.contains(event.target)) menu.open = false; });
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); }
  });
  matchMedia(DESKTOP_QUERY).addEventListener('change', (event) => { if (event.matches) menu.open = false; });
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const variant = section.querySelector('[data-variant-select]');
  const button = section.querySelector('[data-add-button]');
  variant?.addEventListener('change', () => {
    const option = variant.selectedOptions[0];
    const available = option.dataset.available === 'true';
    section.querySelector('[data-variant-price]').textContent = option.dataset.price;
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
  section.querySelectorAll('[data-area-calculator]').forEach((calculator) => {
    calculator.querySelector('[data-calculator-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      const areaInput = calculator.querySelector('[data-area]');
      const allowanceInput = calculator.querySelector('[data-allowance]');
      const area = areaInput.valueAsNumber;
      const allowance = allowanceInput.valueAsNumber;
      const coverage = Number(calculator.dataset.coverage);
      const output = calculator.querySelector('[data-calculator-result]');
      const validArea = areaInput.checkValidity() && Number.isFinite(area);
      const validAllowance = allowanceInput.checkValidity() && Number.isFinite(allowance);
      areaInput.setAttribute('aria-invalid', String(!validArea));
      allowanceInput.setAttribute('aria-invalid', String(!validAllowance));
      if (!validArea || !validAllowance || !Number.isFinite(coverage) || coverage <= 0) {
        output.textContent = calculator.dataset.error;
        if (!validArea) areaInput.focus();
        else if (!validAllowance) allowanceInput.focus();
        return;
      }
      const packs = Math.ceil(area * (1 + allowance / 100) / coverage);
      const quantity = section.querySelector('[data-product-quantity]');
      if (packs > Number(quantity.max)) { output.textContent = calculator.dataset.error; return; }
      quantity.value = packs;
      output.textContent = calculator.dataset.output.replace('__PACKS__', packs).replace('__AREA__', (packs * coverage).toFixed(2));
    });
  });
});

const floor = document.querySelector('[data-enquiry-floor]');
if (floor) floor.value = (new URLSearchParams(location.search).get('floor') || '').slice(0, 200);
